import { IExitForm } from '@/Models'
import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const numReq = 'Field must be a number'
export const reqField = 'Field is required'
export const minFieldReq = 'Accepted range for field is 1 to 5'

export const stepTwoSchema = yup.object().shape({
  trainingRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  supervisorRelationshipRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  fellowEmployeesRelationshipRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  salaryRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  benefitsRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  workloadRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  overallSatisfactionRating: yup
    .number()
    .required(reqField)
    .typeError(numReq)
    .min(1, minFieldReq)
    .max(5, minFieldReq),
  laptopPassword: yup.string().required(reqField),
  benefitsComments: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
})

type RatingField = keyof Pick<
  IExitForm,
  | 'trainingRating'
  | 'supervisorRelationshipRating'
  | 'fellowEmployeesRelationshipRating'
  | 'salaryRating'
  | 'benefitsRating'
  | 'workloadRating'
  | 'overallSatisfactionRating'
>

export const StepTwoComp = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IExitForm>()

  const ratingFields: { name: RatingField; label: string }[] = [
    { name: 'trainingRating', label: 'Training Received' },
    { name: 'supervisorRelationshipRating', label: 'Supervisor Relationship' },
    { name: 'fellowEmployeesRelationshipRating', label: 'Coworker Relationship' },
    { name: 'salaryRating', label: 'Salary Rating' },
    { name: 'benefitsRating', label: 'Benefits Rating' },
    { name: 'workloadRating', label: 'Workload Rating' },
    { name: 'overallSatisfactionRating', label: 'Overall Satisfaction' },
  ]

  return (
    <div className='form-step deselect'>
      <div className='container'>
        <div className='row justify-content-center p-1'>
          <div className='col-10 mt-5 w-100'>
            <h6 className='text-start mb-3 fw-light text-rating'>
              Ratings: 1 = poor; 5 = outstanding. Please rate the following:
            </h6>
          </div>
        </div>

        <div className='form-group row justify-content-center'>
          {ratingFields.map(({ name, label }) => (
            <div className='form-control border-0 col-6 col-md-6 col-lg-6 option-rating' key={name}>
              <label className='form-label  text-start w-100'>{label}:</label>
              <select className='form-select' {...register(name)}>
                <option value=''>Select</option>
                {[1, 2, 3, 4, 5].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              {errors[name] && (
                <p className='text-danger text-start text-sm'>{errors[name]?.message as string}</p>
              )}
            </div>
          ))}

          
          <div className='mb-3 text-start col-md-6 col-lg-5 custom-con'>
            <label>Laptop Password:</label>
            <input className='form-control custom-input' {...register('laptopPassword')} />
            {errors.laptopPassword && (
              <p className='text-danger'>{errors.laptopPassword.message}</p>
            )}
          </div>


          <div className='mb-3 text-start col-md-6 col-lg-5 mt-2'>
            <label>Suggestions for Benefits:</label>
            <textarea className='form-control' {...register('benefitsComments')} />
            {errors.benefitsComments && (
              <p className='text-danger'>{errors.benefitsComments.message}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
